import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.6",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M6 4h9.5A2.5 2.5 0 0 1 18 6.5v5a2.5 2.5 0 0 1-2.5 2.5H10l-3.5 3v-3H6a2.5 2.5 0 0 1-2.5-2.5v-5A2.5 2.5 0 0 1 6 4M26 16.5V20a2.5 2.5 0 0 1-2.5 2.5H23v3l-3.5-3H17a2.5 2.5 0 0 1-2.5-2.5v-1.5M24 9.5q0 3 3 3-3 0-3 3 0-3-3-3 3 0 3-3" }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }